import IconMaterial from './IconMaterial';

export default IconMaterial;
